import { constructFrom as c } from "./constructFrom.js";
import { getDaysInMonth as i } from "./getDaysInMonth.js";
import { toDate as m } from "./toDate.js";
function d(e, n) {
  const t = m(e), r = t.getFullYear(), s = t.getDate(), o = c(e, 0);
  o.setFullYear(r, n, 15), o.setHours(0, 0, 0, 0);
  const a = i(o);
  return t.setMonth(n, Math.min(s, a)), t;
}
export {
  d as default,
  d as setMonth
};
//# sourceMappingURL=setMonth.js.map
